<script setup lang="ts">
    import { useDashboardLibraryStore } from '@/js/stores/dashboardLibrary';
    import DashboardLibraryItem from './DashboardLibraryItem.vue';
    import { ILibraryDashboard } from '@/js/services/api/library/types';
    import { watch } from 'vue';

    interface Props {
        dashboards: ILibraryDashboard[];
        searchString: string;
    }

    const props = defineProps<Props>();

    const dashboardLibrary = useDashboardLibraryStore();

    watch(
        () => props.dashboards.length,
        () => dashboardLibrary.setInitialDashboards(props.dashboards),
        { immediate: true }
    );
    watch(
        () => props.searchString,
        (searchString) => {
            dashboardLibrary.filterDashboards(searchString);
        }
    );
</script>
<template>
    <div class="h-full grid grid-cols-[1fr] lg:grid-cols-[1fr_1fr] gap-3">
        <DashboardLibraryItem
            v-for="dashboard in dashboardLibrary.filteredDashboards"
            :key="dashboard.id"
            :dashboard="dashboard"
        />
    </div>
</template>
